import { render, staticRenderFns } from "./FormSelect2Input.vue?vue&type=template&id=822ec27e&scoped=true"
import script from "./FormSelect2Input.vue?vue&type=script&lang=js"
export * from "./FormSelect2Input.vue?vue&type=script&lang=js"
import style0 from "./FormSelect2Input.vue?vue&type=style&index=0&id=822ec27e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822ec27e",
  null
  
)

export default component.exports